import { render } from "./PrivacySubsection.vue?vue&type=template&id=e6604e74&scoped=true"
import script from "./PrivacySubsection.vue?vue&type=script&lang=js"
export * from "./PrivacySubsection.vue?vue&type=script&lang=js"

import "./PrivacySubsection.vue?vue&type=style&index=0&id=e6604e74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6604e74"]])

export default __exports__